import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Form } from 'formsy-react-2'
import { push } from 'react-router-redux'
import R, { isEmpty, isNil } from 'ramda'
import moment from 'moment'
import { Button, Modal, InputTag, Select, TextInput, DatePicker, TextIcon } from 'advenio-components'
import styled from 'styled-components'
import { formatDecimalNumber, parseToInt } from '../../utils/Utils'
import OriginalIsland from '../../Components/Island/Island'
import ServiceDetails from '../../Containers/AddContract/ServiceDetails'
import CompaniesActions from '../../Data/Redux/CompaniesRedux'
import ContractsActions from '../../Data/Redux/ContractsRedux'

const Container = styled.div`
  margin-bottom: 24px;
`
const Island = styled(OriginalIsland).attrs({
  paddedBody: true,
  headingFontSize: 16,
})`
  margin-bottom: 24px;
  box-shadow: 0 4px 16px rgba(0,0,0, .15);
  ${({ service }) => service && `
    margin-top: 2%;
    margin-bottom: 9%;
  `}
`
const InputContainer = styled.div`
  margin-bottom: 24px;
  ${({ datePicker }) => datePicker && `
    flex: 2;
    margin: 0 0 0px 8px;
    width:30%;
    display:inline-block;
  `}
  ${({ shift }) => shift && `
    flex: 2;
    margin: 0 0 0px 8px;
    width: 390px;
    display:inline-block;
  `}
  ${({ name }) => name && `
    margin-bottom: 0px;
  `}
  ${({ student_limit }) => student_limit && `
    width:50%;
    display:inline-block;
  `}
`
const SelectContainer = styled.div`
  width: 38%;
  display:inline-block;
  ${({ product }) => product && `
   margin-bottom: 0px;
   width:48%;
   margin-right:18px;
  `}
`
const HiddenInputContainer = styled.div`
  display: none;
`
const ButtonsContainer = styled.div`
  margin-left: 688px;
  margin-top: -5%;
  width:175px;
  ${({ back }) => back && `
    margin-bottom: 20px;
    margin-top: -65px;
    margin-left: 717px;
    @media only screen and (min-width: 1493px) {
      margin-left: 89%;
    }
  `}
`

const Botton = styled(Button)`
  ${({ service }) => service && `
    margin-right: 658px;
    margin-left: -49px;
    @media only screen and (min-width: 1493px) {
      margin-left: -349px;
    }
  `}
`
const getType = (type, total, tax_pct) => {
  if (type !== null) {
    if (type === 'inital') {
      return parseToInt(formatDecimalNumber(Number(total) * (tax_pct / 100 + 1)))
    }

    return parseToInt(formatDecimalNumber(Number(total) / (tax_pct / 100 + 1)))
  }

  Number(total)
}

const getFormatExtra = ({
  consumable_type_id,
  total,
  support_as_pct,
},
type = null,
tax_pct = null,
) => ({
  consumable_type_id: Number(consumable_type_id),
  total: getType(type, total, tax_pct),
  support_as_pct: Number(support_as_pct),
})


const getFormatProduct = ({
  product_name,
  country_product_id,
  monthly_total,
  enrollment_total,
  reenrollment_total,
  materials_total,
  monthly_support,
  enrollment_support,
  reenrollment_support,
  materials_support,
  students_limit,
  sibling_discount,
  support_as_pct,
  support_per_child,
  extra_support,
  students_totals,
  type,
  country,
}) => {
  let product = {}
  if (type === 'inital') {
    const { operating_parameters: { tax_pct } } = country
    product = {
      product_name,
      country_product_id: Number(country_product_id),
      monthly_total: Number(monthly_total > 0) ? parseToInt(formatDecimalNumber(Number(monthly_total) * (tax_pct / 100 + 1))) : 0,
      enrollment_total: Number(enrollment_total > 0) ? parseToInt(formatDecimalNumber(Number(enrollment_total) * (tax_pct / 100 + 1))) : 0,
      reenrollment_total: Number(reenrollment_total > 0) ? parseToInt(formatDecimalNumber(Number(reenrollment_total) * (tax_pct / 100 + 1))) : 0,
      materials_total: Number(materials_total > 0) ? parseToInt(formatDecimalNumber(Number(materials_total) * (tax_pct / 100 + 1))) : 0,
      monthly_support: monthly_support !== undefined ? parseToInt(formatDecimalNumber(Number(monthly_support) * (tax_pct / 100 + 1))) : 0,
      enrollment_support: enrollment_support !== undefined ? parseToInt(formatDecimalNumber(Number(enrollment_support) * (tax_pct / 100 + 1))) : 0,
      reenrollment_support: reenrollment_support !== undefined ? parseToInt(formatDecimalNumber(Number(reenrollment_support) * (tax_pct / 100 + 1))) : 0,
      materials_support: materials_support !== undefined ? parseToInt(formatDecimalNumber(Number(materials_support) * (tax_pct / 100 + 1))) : 0,
      students_limit: students_limit ? Number(students_limit) : null,
      students_totals: students_totals ? Number(students_totals) : 0,
      sibling_discount,
      support_as_pct,
      support_per_child,
    }
    if (extra_support !== undefined) {
      product = {
        ...product,
        extra_support: Object.values(extra_support).length > 0 ? Object.values(extra_support).filter(extra => extra.consumable_type_id > 0).map(extra => getFormatExtra(extra, type, tax_pct)) : [],
      }
    }
  } else if (type === 'sent') {
    const { operating_parameters: { tax_pct } } = country
    product = {
      product_name,
      country_product_id: Number(country_product_id),
      price: {
        monthly: Number(monthly_total > 0) ? parseToInt(formatDecimalNumber(Number(monthly_total) / (tax_pct / 100 + 1))) : 0,
        enrollment: Number(enrollment_total > 0) ? parseToInt(formatDecimalNumber(Number(enrollment_total) / (tax_pct / 100 + 1))) : 0,
        reenrollment: Number(reenrollment_total > 0) ? parseToInt(formatDecimalNumber(Number(reenrollment_total) / (tax_pct / 100 + 1))) : 0,
        materials: Number(materials_total > 0) ? parseToInt(formatDecimalNumber(Number(materials_total) / (tax_pct / 100 + 1))) : 0,
      },
      company_support: {
        monthly: monthly_support !== undefined ? parseToInt(formatDecimalNumber(Number(monthly_support) / (tax_pct / 100 + 1))) : 0,
        enrollment: enrollment_support !== undefined ? parseToInt(formatDecimalNumber(Number(enrollment_support) / (tax_pct / 100 + 1))) : 0,
        reenrollment: reenrollment_support !== undefined ? parseToInt(formatDecimalNumber(Number(reenrollment_support) / (tax_pct / 100 + 1))) : 0,
        materials: materials_support !== undefined ? parseToInt(formatDecimalNumber(Number(materials_support) / (tax_pct / 100 + 1))) : 0,
      },
      students_limit: students_limit ? Number(students_limit) : null,
      sibling_discount: sibling_discount !== undefined ? sibling_discount : 0,
      support_as_pct: support_as_pct !== undefined ? support_as_pct : 0,
      support_per_child: support_per_child !== undefined ? support_per_child : 0,
    }
    if (extra_support !== undefined) {
      product = {
        ...product,
        extra_support: Object.values(extra_support).length > 0 ? Object.values(extra_support).filter(extra => extra.consumable_type_id > 0).map(extra => getFormatExtra(extra, type, tax_pct)) : [],
      }
    }
  }

  return product
}


const newContract = {
  name: null,
  countryId: null,
  deal_closed_on: null,
  expires_on: null,
  students_limit: null,
  limit_reservation: {
    morning_limit_shift: null,
    afternoon_limit_shift: null,
    center_limit_morning: null,
    center_limit_afternoon: null,
  },
  contract_type: null,
  center_ids: [],
  products: [{
    product_name: null,
    country_product_id: 0,
    monthly_total: 0,
    enrollment_total: 0,
    reenrollment_total: 0,
    materials_total: 0,
    monthly_support: 0,
    enrollment_support: 0,
    reenrollment_support: 0,
    materials_support: 0,
    sibling_discount: 0,
    support_as_pct: false,
    support_per_child: false,
    students_limit: null,
    students_totals: 0,
    extra_support: [
    ],
  },
  ],
}

class AddContractDetails extends Component {
  state = {
    contractType: '',
    canSubmit: false,
    id: 0,
    contract: newContract,
    studentsLimit: null,
  }

  componentWillMount() {
    const { match: { path }, match, company: { contracts }, company } = this.props
    const { contract } = this.state
    const id = match.params.id
    const contractType = path.includes('with-support') ? 'with-support' : 'without-support' // strip the final section of the pathname
    this.setState({ contractType, id })
    if (contracts !== undefined) {
      this.handleLoadContract(company)
    }
  }

  componentWillUnmount() {
    this.props.resetContract()
  }

  componentWillReceiveProps(nextProps) {
    const { match: { params }, company } = this.props

    if (nextProps.successSave) {
      this.props.goBackToProfile(params.id)
    }
    if (company !== nextProps.company) {
      this.handleLoadContract(nextProps.company)
    }
  }

  handleLoadContract = (companyInit = null) => {
    console.log('loadContract')
    const { match, company: { contracts: compContracts }, company: dataCompany } = this.props
    const idContract = Number(match.params.contractId)
    let contracts = compContracts
    let company = dataCompany
    if (compContracts === undefined && companyInit !== null) {
      contracts = companyInit.contracts
      company = companyInit
    }
    const { country } = company
    if (idContract > 0 && contracts !== undefined) {
      const contract = R.clone(contracts.filter(contract => contract.id === idContract)[0])
      console.log('🚀 ~ file: AddContractDetails.jsx:282 ~ AddContractDetails ~ contracts:', contract)
      const updateinfo = {
        ...contract,
        center_ids: contract.centers.length > 0 ? contract.centers.map(center => (center.id)) : [],
        countryId: company.country.id,
        products: contract.products.map(product => getFormatProduct({ ...product, type: 'inital', country })),
        // limit_reservation: !isNil(contract.limit_reservation)  || !isEmpty(contract.limit_reservation) ? contract.limit_reservation : newContract.limit_reservation
      }
      delete updateinfo.company
      delete updateinfo.created_at
      delete updateinfo.updated_at
      delete updateinfo.id
      delete updateinfo.centers
      // console.log(updateinfo);
      this.setState({ contract: updateinfo })
    }
  }

  handleStudentLimit = e =>
    this.setState({ studentsLimit: Number(e.target.value) })

  handleChange = (data) => {
    const formData = this.form && this.form.getModel()

    if (formData !== null) {
      if (formData.products !== undefined) {
        const contract = {
          ...formData,
          country_id: Number(formData.country_id),
          products: formData.products.map(product => ({
            ...product,
            country_product_id: Number(product.country_product_id),
            extra_support: product.extra_support !== undefined ? Object.values(product.extra_support).map(extra => getFormatExtra(extra)) : [],
          })),
        }
        console.log('change', formData)
        this.setState({ contract })
      }
    }
  }

  handledAddExtra = (index) => {
    const formData = this.form.getModel()
    const newExtra = {
      consumable_type_id: 0,
      total: 0,
      support_as_pct: 0,
    }
    const contract = {
      ...formData,
      country_id: Number(formData.country_id),
      products: formData.products.map(product => ({
        ...product,
        country_product_id: Number(product.country_product_id),
        extra_support: product.extra_support !== undefined ? Object.values(product.extra_support).map(extra => getFormatExtra(extra)) : [],
      })),
    }
    contract.products[index].extra_support.push(newExtra)
    contract.products[index].extra_support.map(extra => getFormatExtra(extra))
    this.setState({ contract })
  }

  handledDeleteExtra = (indexProduct, index) => {
    const newContract = this.state.contract
    newContract.products[indexProduct].extra_support = R.remove(index, 1, newContract.products[indexProduct].extra_support)
    this.setState({ contract: newContract })
  }


  handledAddService = () => {
    const newContract = this.state.contract
    const newProduct = {
      product_name: null,
      country_product_id: 0,
      monthly_total: 0,
      enrollment_total: 0,
      reenrollment_total: 0,
      materials_total: 0,
      monthly_support: 0,
      enrollment_support: 0,
      reenrollment_support: 0,
      materials_support: 0,
      support_as_pct: false,
      support_per_child: false,
      students_limit: 0,
      students_totals: 0,
      extra_support: [
      ],
    }
    newContract.products.push(newProduct)
    this.setState({ contract: newContract })
  }

  handledDeleteService = (index) => {
    const newContract = this.state.contract
    newContract.products = R.remove(index, 1, newContract.products)
    this.setState({ contract: newContract })
  }

  handledChangeService = (e) => {
    const formData = R.clone(this.state.contract) // this.form && this.form.getModel()
    const productId = e.target.value
    const itemProduct = formData.products.filter(product => product.country_product_id === Number(productId))
    if (itemProduct.length > 0) {
      const index = R.findIndex(R.propEq('country_product_id', itemProduct[0].country_product_id))(formData.products)
      formData.products = R.remove(index, 1, formData.products)
    }
    this.setState({ contract: formData })
  }

  submitForm = (data) => {
    const infoload = data
    const { match: { path, params }, storeContract, updateContract, company: { country } } = this.props
    const { id } = this.state
    const contractType = path.includes('with-support') ? 'With Support' : 'Without Support'
    infoload.contract_type = contractType

    delete infoload.country_id
    if (infoload.center_ids.length === 0) {
      delete infoload.center_ids
    }
    const sendInfo = {
      ...infoload,
      students_limit: infoload.students_limit ? Number(infoload.students_limit) : null,
      morning_limit_shift: infoload.limit_reservation.morning_limit_shift ? Number(infoload.limit_reservation.morning_limit_shift) : null,
      afternoon_limit_shift: infoload.limit_reservation.afternoon_limit_shift ? Number(infoload.limit_reservation.afternoon_limit_shift) : null,
      center_limit_morning: infoload.limit_reservation.center_limit_morning ? Number(infoload.limit_reservation.center_limit_morning) : null,
      center_limit_afternoon: infoload.limit_reservation.center_limit_afternoon ? Number(infoload.limit_reservation.center_limit_afternoon) : null,
      products: infoload.products !== undefined ? infoload.products.map(product => getFormatProduct({ ...product, type: 'sent', country })) : [],
    }
    delete sendInfo.limit_reservation
    if (Number(params.contractId) !== 0) {
      updateContract(params.contractId, sendInfo)
    } else {
      storeContract(id, sendInfo)
    }
  }

  enableSubmit = () => this.setState({ canSubmit: true })
  disableSubmit = () => this.setState({ canSubmit: false })

  renderCenterOptions = () => {
    const { company } = this.props
    return company.centers.map(center => ({
      id: center.id,
      label: center.name,
      value: center.id,
    }))
  }

  renderCountryOptions = () => {
    const { countries } = this.props

    if (!countries) return []

    return countries.map(country => ({
      id: country.id,
      label: country.name,
      value: country.id,
    }))
  }

  renderProductOptions = () => {
    const formData = this.form && this.form.getModel()
    const countryId = formData && formData.country_id
    const { countries } = this.props
    const { contract } = this.state
    const productsSelected = []
    const cmp = (x, y) => x.product_name === y.product_name
    const sortByNameCaseInsensitive = (a, b) => {
      // converting to uppercase to have case-insensitive comparison
      const name1 = a.product_name.toUpperCase()
      const name2 = b.product_name.toUpperCase()

      let comparison = 0

      if (name1 > name2) {
        comparison = 1
      } else if (name1 < name2) {
        comparison = -1
      }
      return comparison
    }

    contract.products.forEach((p) => {
      productsSelected.push(p)
    })

    if (!countries || !countryId) return []

    const country = countries.filter(country => country.id == countryId)[0]
    const countryProducts = country.products
    const filterProducts = R.differenceWith(cmp, countryProducts, productsSelected)

    filterProducts.sort(sortByNameCaseInsensitive)

    return filterProducts.map(product => ({
      id: product.id,
      label: product.product_name,
      value: product.id,
    }))
  }
  renderConsumiblesCategoryOptions = () => {
    const { consumiblesCategory } = this.props
    const category = [{ id: 0,
      label: 'N/A',
      value: 0 }]
    if (consumiblesCategory) {
      consumiblesCategory.map(Category =>
        category.push({ id: Category.id,
          label: Category.translations,
          value: Category.id,
        }))
    }
    return category
  }


  render() {
    const { loadingCenters, loadingCompany, goBackToProfile, company: { name } } = this.props
    const { canSubmit, id, contract, studentsLimit, contractType } = this.state
    const formData = this.form && this.form.getModel()
    const centers = name !== undefined ? this.renderCenterOptions() : []
    const products = this.renderProductOptions()
    const category = this.renderConsumiblesCategoryOptions()
    console.log('render', contract)
    return (
      <Container>
        {(loadingCompany || loadingCenters) && (contract.contract_type !== undefined) && <Modal isOpened loading />}
        {!loadingCompany && (
          <Form
            ref={(form) => {
              this.form = form
            }}
            onValidSubmit={this.submitForm}
            onValid={this.enableSubmit}
            onInvalid={this.disableSubmit}
            onChange={() => { this.handleChange() }}
          >
            <h1>Contrato {contractType === 'with-support' ? '(Con Descuento)' : '(Sin Descuento)'} - {name}</h1>
            <ButtonsContainer back >
              <Botton primary onClick={() => goBackToProfile(id)} >Regresar</Botton>
            </ButtonsContainer>
            <Island heading="Datos Generales del Contrato">
              <InputContainer name="true">
                <TextInput
                  required
                  type="text"
                  id="name"
                  name="name"
                  label="Nombre del Contrato"
                  value={contract.name ? contract.name : null}
                />
              </InputContainer>
              <SelectContainer>
                <Select
                  required
                  name="country_id"
                  label="¿En qué país se aplicará el contrato?"
                  options={this.renderCountryOptions()}
                  value={contract.country_id ? contract.country_id : 1}
                  placeholder="Selecciona a un país"
                />
              </SelectContainer>
              <InputContainer datePicker>
                <DatePicker
                  name="deal_closed_on"
                  label="Fecha de cierre contrato"
                  value={contract.deal_closed_on ? moment(contract.deal_closed_on).format('YYYY-MM-DD') : null}
                  disableAfterToday
                />
              </InputContainer>
              <InputContainer datePicker>
                <DatePicker
                  name="expires_on"
                  label="Fecha de vigencia"
                  value={contract.expires_on ? moment(contract.expires_on).format('YYYY-MM-DD') : null}
                  disableBeforeToday
                />
              </InputContainer>
              <InputContainer>
                <TextInput
                  type="text"
                  name="students_limit"
                  label="¿Cuál es el limite de niños que se pueden inscribir en el Contrato?"
                  help="Dejar el campo en blanco si no hay limite"
                  onChangeCallback={(e) => { this.handleStudentLimit(e) }}
                  value={contract.students_limit !== null ? contract.students_limit : null}
                  // validationErrors={{ isInt: 'El limite debe ser un número entero' }}
                />
              </InputContainer>
            </Island>
            <Island heading="Reservaciones B2B">
              <InputContainer shift>
                <TextInput
                  name="limit_reservation.morning_limit_shift"
                  label="Limite turno mañana"
                  type="number"
                  value={!isNil(contract.limit_reservation) ? contract.limit_reservation.morning_limit_shift : null}
                  help={'Limite de estudiantes en turno de mañana'}
                />
              </InputContainer>
              <InputContainer shift>
                <TextInput
                  name="limit_reservation.afternoon_limit_shift"
                  label="Limite turno tarde"
                  type="number"
                  help={'Limite de estudiantes en turno de tarde'}
                  value={!isNil(contract.limit_reservation) ? contract.limit_reservation.afternoon_limit_shift : null}
                />
              </InputContainer>
              <InputContainer shift>
                <TextInput
                  name="limit_reservation.center_limit_morning"
                  label="Limite por centro turno mañana"
                  type="number"
                  help={'Limite de estudiantes por centro en turno de mañana'}
                  value={!isNil(contract.limit_reservation) ? contract.limit_reservation.center_limit_morning : null}
                />
              </InputContainer>
              <InputContainer shift>
                <TextInput
                  name="limit_reservation.center_limit_afternoon"
                  label="Limite por centro turno tarde"
                  type="number"
                  help={'Limite de estudiantes por centro en turno de tarde'}
                  value={!isNil(contract.limit_reservation) ? contract.limit_reservation.center_limit_afternoon : null}
                />
              </InputContainer>
            </Island>
            {/* {centers.length > 0 &&( */}
            <Island heading="Centros">
              <InputContainer>
                <InputTag
                  name="center_ids"
                  label="Centros al que aplica este contrato"
                  options={centers}
                  value={contract.center_ids ? contract.center_ids : null}
                  help={formData && formData.country_id ? 'Selecciona un centro' : 'Selecciona primero el país'}
                />
              </InputContainer>
            </Island>
            {/* )} */}
            <Botton service onClick={this.handledAddService} primary disabled={products.length === 0} >
              <TextIcon iconType="plus" label="Servicio" iconViewBox="-2 -2 24 24" />
            </Botton>
            { products.length > 0 && (contract.products.map((product, index) => (
              <ServiceDetails
                key={`products[${index}]`}
                product={product}
                products={products}
                category={category}
                studentsLimit={studentsLimit}
                contractType={contractType}
                index={index}
                studentsTotals={product.students_totals}
                addExtra={this.handledAddExtra}
                deleteExtra={this.handledDeleteExtra}
                deleteService={this.handledDeleteService}
                changeService={this.handledChangeService}
                handledChange={this.handleChange}
              />
            )))}
            <ButtonsContainer>
              <Botton type="submit" success disabled={!canSubmit}>Guardar</Botton>
            </ButtonsContainer>
          </Form>
        )}
      </Container>
    )
  }
}

AddContractDetails.propTypes = {
  /** Data attributes from the current URI */
  match: PropTypes.object.isRequired,
  /** The Company's profile data */
  company: PropTypes.object.isRequired,
  /** The array of countries where Advenio operates */
  countries: PropTypes.array.isRequired,
  /** Flag indicating that the Available Centers data is loading */
  loadingCenters: PropTypes.bool.isRequired,
  /** Flag indicating the Contract has been successfully stored in the API */
  successSave: PropTypes.bool.isRequired,
  /** Flag indicating that the Company data is loading */
  loadingCompany: PropTypes.bool.isRequired,
  /** Store a new Contract for this Company */
  storeContract: PropTypes.func.isRequired,
  /** Update a Contract for this Company */
  updateContract: PropTypes.func.isRequired,
  /** Naviage back to the Company's profile page */
  goBackToProfile: PropTypes.func.isRequired,
  /** Reset the new contract redux store */
  resetContract: PropTypes.func.isRequired,
}

AddContractDetails.defaultProps = {
  company: {},
}

const mapStateToProps = ({ companies, countries, ...state }) => ({
  company: companies.getOne.result,
  countries: countries.get.results,
  loadingCenters: companies.getAvailableCenters.fetching,
  loadingCompany: companies.getOne.fetching ||
                  countries.get.fetching ||
                  state.consumiblesCategory.get.fetching ||
                  companies.newContract.saving ||
                  state.contracts.get.fetching,
  successSave: companies.newContract.success,
  consumiblesCategory: state.consumiblesCategory.get.results,

})

const mapDispatchToProps = dispatch => ({
  storeContract: (id, payload) => dispatch(CompaniesActions.contractCreateRequest(id, payload)),
  updateContract: (id, payload) => dispatch(ContractsActions.contractsUpdateRequest(id, payload)),
  resetContract: () => dispatch(CompaniesActions.contractCreateReset()),
  setParamters: () => dispatch(CompaniesActions.setParamters()),
  goBackToProfile: id => dispatch(push(`/companies/${id}`)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddContractDetails))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/AddContractDetails.jsx